export const LOGIN_SUCCESSFULL = 0;
export const LOGIN_FAILED = 1;
export const LOGIN_TEMPORARILYUNAVAILABLE = 2;
export const LOGIN_PASSWORDFIRSTSETUP = 3;
export const LOGIN_CHANGEPASSWORD = 4;
export const LOGIN_SECUREPASSWORDNOTSET = 5;
export const LOGIN_USERLOCKED = 6;
export const LOGIN_RESTRICTEDEMPLOYEEHIRED = 7;
export const LOGIN_SSOUSERNOTLINKED = 8;
export const LOGIN_INACTIVEPORTAL = 9;
export const LOGIN_MULTIPLECOMPANIES = 100;